import React from 'react';
import './ForgotPassword.css';
import { Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from 'reactstrap';
import { doPasswordReset } from '../../../../firebase/api/auth';
import { compose } from 'recompose';
import WithRouter from '../../../../helpers/WithRouter';

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            error: null,
            successSend: false,
        };
    }

    onSubmit = event => {
        const { email } = this.state;
        doPasswordReset(email)
            .then(res => {
                this.setState({ successSend: true });
                console.log(res);
            })
            .catch(error => {
                this.setState({ error });
            });
        event.preventDefault();
    };

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal,
        }));
    }

    render() {
        const { email, password, error, successSend } = this.state;
        const { toggle, modal, redirectToSignIn } = this.props;
        const isInvalid = email === '';
        return (
            <Modal isOpen={modal} toggle={toggle} className={'sign-in-modal-form'}>
                <ModalHeader toggle={toggle}>Forgot Password</ModalHeader>
                <ModalBody>
                    {successSend ? (
                        <p>Check your email</p>
                    ) : (
                        <p>
                            Enter your email address. We'll email you instructions to reset your
                            password.
                        </p>
                    )}
                    <Form action="" method="post" name="login" onSubmit={this.onSubmit}>
                        <FormGroup>
                            <Label for="exampleEmail">Email address</Label>
                            <Input
                                type="email"
                                name="email"
                                onChange={this.onChange}
                                id="exampleEmail"
                                placeholder="Enter Email"
                            />
                        </FormGroup>
                        <div className="submit-button">
                            <Button
                                className="forgot"
                                outline
                                color="primary"
                                style={{ width: '35%' }}
                                onClick={redirectToSignIn}
                            >
                                Back
                            </Button>
                            <Button
                                type="submit"
                                color="primary"
                                disabled={isInvalid || successSend}
                                className="submit"
                                style={{ width: '60%' }}
                            >
                                Reset Password
                            </Button>
                        </div>
                        {error && <p>{error.message}</p>}
                    </Form>
                </ModalBody>
            </Modal>
        );
    }
}

export default compose(WithRouter)(ForgotPassword);
